"use strict";

exports.__esModule = true;
exports.getDataItemsForProvidedSource = exports.convertRealTimeDataFromTimelines = exports.convertDataToEchartsFormat = exports.convertDataItemsToEchartsDataItemFormat = void 0;
var _getDeviceDataItems = require("../../Device/common/getDeviceDataItems");
var _Utils = require("../../../Utils");
var _widget = require("./widget");
var convertDataToEchartsFormat = exports.convertDataToEchartsFormat = function convertDataToEchartsFormat(rawData, deviceUuid, dataItems) {
  return rawData.reduce(function (acc, result, index) {
    var dataItemName = dataItems[index].name;
    var dataForItem = (0, _Utils.returnEmptyArrayIfUndefined)(result.data);
    dataForItem.forEach(function (dataRow) {
      acc[deviceUuid] = (0, _Utils.returnEmptyObjectIfUndefined)(acc[deviceUuid]);
      acc[deviceUuid][dataItemName] = (0, _Utils.returnEmptyArrayIfUndefined)(acc[deviceUuid][dataItemName]);
      acc[deviceUuid][dataItemName].push([dataRow.key, dataRow.value]);
    });
    return acc;
  }, {});
};
var convertRealTimeDataFromTimelines = exports.convertRealTimeDataFromTimelines = function convertRealTimeDataFromTimelines(data) {
  return data.reduce(function (acc, result) {
    acc.push(result.map(function (valueObj) {
      return [valueObj.interval.endMillis, valueObj.value];
    }));
    return acc;
  }, []);
};
var convertDataItemsToEchartsDataItemFormat = exports.convertDataItemsToEchartsDataItemFormat = function convertDataItemsToEchartsDataItemFormat(dataItems, device) {
  return dataItems.map(function (dataItem) {
    var _deviceDataItem$unit;
    var deviceDataItem = (0, _getDeviceDataItems.getDeviceDataItems)(device).find(function (di) {
      return di.name === dataItem.dataItemName;
    });
    if (!deviceDataItem) {
      return null;
    }
    return Object.assign({
      dataItemName: dataItem.dataItemName,
      displayName: dataItem.dataItemName,
      color: dataItem.color,
      unit: (_deviceDataItem$unit = deviceDataItem == null ? void 0 : deviceDataItem.unit) != null ? _deviceDataItem$unit : ""
    }, deviceDataItem);
  }).filter(Boolean);
};
var getDataItemsForProvidedSource = exports.getDataItemsForProvidedSource = function getDataItemsForProvidedSource(device, dataItemSource, realtimeItems, historicalItems, dataItems) {
  if (dataItemSource === void 0) {
    dataItemSource = _widget.REALTIME_ITEMS;
  }
  if (realtimeItems === void 0) {
    realtimeItems = [];
  }
  if (historicalItems === void 0) {
    historicalItems = [];
  }
  if (dataItems === void 0) {
    dataItems = [];
  }
  if (dataItems.length > 0 || dataItemSource === _widget.MTC_ITEMS) {
    return convertDataItemsToEchartsDataItemFormat(dataItems, device);
  }
  var items = dataItemSource === _widget.HISTORICAL_ITEMS ? historicalItems : realtimeItems;
  var sourceItems = dataItemSource === _widget.HISTORICAL_ITEMS ? device.performanceParameters.historicalDataItems : device.performanceParameters.realtimeDataItems;
  return items.reduce(function (acc, item) {
    if (sourceItems.length > item.dataItemIndex) {
      acc.push(Object.assign({}, sourceItems[item.dataItemIndex], {
        color: item.color,
        dataItemName: sourceItems[item.dataItemIndex].name
      }));
    }
    return acc;
  }, []);
};